/**
 * Centralized product category options used across all quote/contact forms.
 * Update this single file to keep every form in sync.
 */
export const PRODUCT_CATEGORY_OPTIONS = [
  { value: "general", label: "General Enquiry" },
  { value: "artificial-grass", label: "Artificial Grass" },
  { value: "wpc-decking", label: "WPC Decking" },
  { value: "wpc-cladding", label: "WPC Cladding" },
  { value: "ps-cladding", label: "PS Cladding" },
  { value: "acoustic-cladding", label: "Acoustic Cladding" },
  { value: "indoor-cladding", label: "Indoor Cladding" },
  { value: "pvc-wet-wall", label: "Supreme Wet Wall Panels" },
  { value: "uv-marble-sheets", label: "UV Marble Sheets" },
  { value: "flexible-wall-cladding", label: "Flexible Wall Cladding" },
  { value: "spc-flooring", label: "SPC Flooring" },
  { value: "hybrid-flooring", label: "Hybrid Flooring" },
  { value: "hedges-screens", label: "Hedges & Screens" },
  { value: "weed-mats", label: "Weed Mats" },
  { value: "garden-pebbles", label: "Garden Pebbles" },
  { value: "other", label: "Other / Multiple Products" },
] as const;

/** Just the labels, for simpler components that use string[] categories */
export const PRODUCT_CATEGORY_LABELS = PRODUCT_CATEGORY_OPTIONS
  .filter(o => o.value !== "general")
  .map(o => o.label);

/** Options without "General Enquiry" – for product-specific forms (Quote, BulkQuote) */
export const PRODUCT_ONLY_CATEGORY_OPTIONS = PRODUCT_CATEGORY_OPTIONS.filter(
  o => o.value !== "general"
);
